import { GraphQLObjectType, GraphQLNonNull, GraphQLBoolean } from 'graphql'

export interface SlidingTutorialMarkResponse {
  readonly _placeholder: boolean
}

export const SlidingTutorialMarkResponseType = new GraphQLObjectType({
  name: 'SlidingTutorialMarkResponse',
  fields: () => ({
    _placeholder: {
      description:
        'We do not currently have a use case for a return value from this mutation. However, GraphQL requires we have a return value. We are choosing to return an object so that we have flexibility in the future, however we need at least one field. This field has no meaning other than to satisfy that requirement. Mutations that use this type should always return `true` here.',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})
